global.__litium = global.__litium || {};
window.__litium.themeName = 'alf';
global.__litium.themeName = 'alf';

require('./app.js');
